import { fmtMoney, fmtNum } from "@/lib/api";

export function SessionMetricCells({ m, className = "text-sm" }) {
  const profit = m.profit_today ?? m.daily_pl ?? 0;
  const maxDd = m.max_drawdown_today ?? m.drawdown ?? 0;
  return (
    <>
      <td className={`px-3 py-3 font-mono-d ${className}`}>{fmtMoney(m.starting_balance ?? m.balance)}</td>
      <td className={`px-3 py-3 font-mono-d ${className}`}>{fmtMoney(m.closing_balance ?? m.balance)}</td>
      <td className={`px-3 py-3 font-mono-d ${className} ${maxDd > 8 ? "text-[#FF3B30]" : ""}`}>{fmtNum(maxDd)}%</td>
      <td className={`px-3 py-3 font-mono-d ${className} ${profit >= 0 ? "text-[#10B981]" : "text-[#FF3B30]"}`}>{fmtMoney(profit)}</td>
    </>
  );
}

function MetricCell({ label, value, accent }) {
  return (
    <div>
      <span className="text-app-muted text-xs">{label}</span>
      <div className={`font-mono-d tabular-nums ${accent || ""}`}>{value}</div>
    </div>
  );
}

export function SessionMetricGrid({ m, expanded = false }) {
  const profit = m.profit_today ?? m.daily_pl ?? 0;
  const maxDd = m.max_drawdown_today ?? m.drawdown ?? 0;
  const floating = m.floating_pl ?? 0;

  if (!expanded) {
    return (
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
        <MetricCell label="Start Bal" value={fmtMoney(m.starting_balance ?? m.balance)} />
        <MetricCell label="Close Bal" value={fmtMoney(m.closing_balance ?? m.balance)} />
        <MetricCell label="Max DD" value={`${fmtNum(maxDd)}%`} accent={maxDd > 8 ? "text-[#FF3B30]" : ""} />
        <MetricCell label="Profit (Today)" value={fmtMoney(profit)} accent={profit >= 0 ? "text-[#10B981]" : "text-[#FF3B30]"} />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm">
      <MetricCell label="Start Bal" value={fmtMoney(m.starting_balance ?? m.balance)} />
      <MetricCell label="Close Bal" value={fmtMoney(m.closing_balance ?? m.balance)} />
      <MetricCell label="Balance" value={fmtMoney(m.balance)} />
      <MetricCell label="Equity" value={fmtMoney(m.equity)} />
      <MetricCell label="Max DD" value={`${fmtNum(maxDd)}%`} accent={maxDd > 8 ? "text-[#FF3B30]" : ""} />
      <MetricCell label="Profit (Today)" value={fmtMoney(profit)} accent={profit >= 0 ? "text-[#10B981]" : "text-[#FF3B30]"} />
      <MetricCell label="Floating P/L" value={fmtMoney(floating)} accent={floating >= 0 ? "text-[#10B981]" : "text-[#FF3B30]"} />
      <MetricCell label="Withdrawals" value={fmtMoney(m.withdrawals_today ?? 0)} />
      <MetricCell label="Positions" value={fmtNum(m.open_positions ?? 0, 0)} />
    </div>
  );
}
